import { Box, Skeleton, TableCell, TableRow } from '@mui/material';

interface LeaderboardTableSkeletonProps {
  rows?: number;
}

export const LeaderboardTableSkeleton = ({ rows = 10 }: LeaderboardTableSkeletonProps) => {
  const leaderboardList = (item: number) => {
    return (
      <TableRow
        key={item}
        sx={{
          '&:last-child td': {
            borderBottom: 'none',
          },
        }}
      >
        <TableCell sx={{ py: 2, width: { xs: '40px', sm: '60px' }, px: { xs: 1, sm: 2 } }}>
          <Skeleton variant="text" width={20} height={20} />
        </TableCell>
        <TableCell sx={{ py: 2, px: { xs: 1, sm: 2 } }}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
            <Skeleton variant="circular" width={40} height={40} />
            <Box>
              <Skeleton variant="text" width={150} height={20} />
              <Skeleton variant="text" width={70} height={16} />
            </Box>
          </Box>
        </TableCell>
        <TableCell align="right" sx={{ py: 2, pr: 4 }}>
          <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
            <Skeleton variant="text" width={80} height={20} />
          </Box>
        </TableCell>
        <TableCell
          align="right"
          sx={{ py: 2, display: { xs: 'none', md: 'table-cell' }, width: '120px' }}
        >
          <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
            <Skeleton variant="text" width={80} height={20} />
          </Box>
        </TableCell>
      </TableRow>
    );
  };

  return <>{Array.from({ length: rows }).map((_, index) => leaderboardList(index))}</>;
};
